export default {
      id: "oc-res-network-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-res-network",
      toString: function () {
        return this.url;
      }
    }